module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('autocomplete-category', {
    ref: "autocompleteCategory",
    attrs: {
      "label": null,
      "placeholder-label": _vm.placeholder
    },
    on: {
      "update:category": _vm.setCategoryId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-4 d-flex"
  }, [_c('loader-button', {
    staticClass: "form-group",
    attrs: {
      "block": "",
      "variant": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('lists.download')) + "\n\t\t\t")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04ff4246"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/ListsDownloadButton.vue
// module id = 1275
// module chunks = 1